<template>
    <t-modal
        v-model="openModal"
        :classes="classes">
        <div class="">
            <div class="py-6 px-6 lg:px-8">
                <h3 class="mb-4 text-xl font-medium text-gray-900 dark:text-white">
                    {{ __('Hírlevél') }}
                </h3>
                <p>
                    <portal-target
                        v-if="portalAvailable"
                        name="newsletter-popup-description"
                    />
                </p>

                <div v-if="success" class="row">
                    <div class="col-md-12">
                        <div class="alert alert-success">
                            <strong>{{ __('Siker!') }}</strong>
                            {{ __('A feliratkozás aktiválásához szükséges linket elküldtük az email címedre!') }}
                        </div>
                    </div>
                </div>

                <div>
                    <label for="name" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                        {{ __('Név') }}
                    </label>
                    <input type="text"
                           name="name"
                           id="name"
                           v-model="name"
                           :class="{'border-red-500': errors && errors['name']}"
                           class="mb-2  border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                           :placeholder="__('Név')"
                           required>
                    <form-error
                        field="name"
                        :errors="errors"
                    />
                </div>
                <div>
                    <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                        {{ __('Email') }}
                    </label>
                    <input type="email"
                           name="email"
                           id="email"
                           v-model="email"
                           :class="{'is-invalid': errors && errors['email']}"
                           class="mb-2  bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                           :placeholder="__('Email')"
                           required>
                    <form-error
                        field="email"
                        :errors="errors"
                    />
                </div>

                <div class="mb-2">
                    <div class="flex items-start">
                        <div class="flex items-center h-5">
                            <input id="remember"
                                   type="checkbox"
                                   v-model="privacyPolicy"
                                   :class="{'border-red-500': errors && errors['privacy_policy']}"
                                   class="w-4 h-4 bg-gray-50 rounded border border-gray-300 focus:ring-3 focus:ring-blue-300 dark:bg-gray-600 dark:border-gray-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800"
                                   required>
                        </div>
                        <label for="remember" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                            <portal-target
                                v-if="portalAvailable"
                                name="newsletter-popup-privacy-policy"
                            />
                        </label>
                    </div>

                    <form-error
                        class="mb-2"
                        field="privacy_policy"
                        :errors="errors"
                    />
                </div>


                <button
                    type="submit"
                    @click="subscribe"
                    class="w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                    {{ __('Feliratkozás') }}
                </button>
            </div>
        </div>
    </t-modal>
</template>

<script>
export default {
    name: 'NewsletterPopup',

    props: {
        url: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            name: null,
            email: null,
            privacyPolicy: false,
            openModal: true,
            errors: null,
            success: false,
            classes: {
                overlay: 'overflow-auto scrolling-touch left-0 top-0 bottom-0 right-0 w-full h-full fixed z-2000 bg-black bg-opacity-50',
                wrapper: 'relative mx-auto z-50 max-w-4xl px-3 py-12',
                modal: 'relative bg-white rounded-lg shadow dark:bg-gray-700',
                body: 'p-3',
                header: 'border-b border-gray-100 p-3 rounded-t',
                footer: 'bg-gray-100 p-3 rounded-b',
                close: 'bg-gray-100 text-gray-600 rounded-full absolute right-0 top-0 -m-3 h-8 w-8 transition duration-100 ease-in-out hover:bg-gray-200 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
                closeIcon: 'fill-current h-4 w-4',
                overlayEnterClass: 'opacity-0',
                overlayEnterActiveClass: 'transition ease-out duration-100',
                overlayEnterToClass: 'opacity-100',
                overlayLeaveClass: 'opacity-100',
                overlayLeaveActiveClass: 'transition ease-in duration-75',
                overlayLeaveToClass: 'opacity-0',
                enterClass: '',
                enterActiveClass: '',
                enterToClass: '',
                leaveClass: '',
                leaveActiveClass: '',
                leaveToClass: '',
            },
        }
    },

    computed: {
        portalAvailable() {
            return 'PortalTarget' in this.$options.components
        }
    },

    methods: {
        async subscribe() {
            this.errors = null

            try {
                await axios.post(this.url, {
                    name: this.name,
                    email: this.email,
                    privacy_policy: this.privacyPolicy
                })

                this.success = true
            } catch (error) {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
